import React, { useState, useCallback, useMemo } from "react";
import { updateBoard } from "../../../../../sevices/apiBoards";
import FormDialog from "../../../../../components/Dialog/FormDialog";
import { Typography } from "@mui/material";
import useMutate from "../../../../../hooks/useMutate";

function Accessibility({ isPrivate = false, params }) {
  const [status, setStatus] = useState(isPrivate);
  const [loading, setLoading] = useState(false);
  const [privatDialog, setPrivatDialog] = useState(false);

  const handleCloseDialog = useCallback(() => {
    setPrivatDialog(false);
  }, []);

  const data = useMemo(() => ({ is_private: !isPrivate }), [isPrivate]);

  const { mutate: archiveMutate } = useMutate(
    updateBoard,
    ["boards"],
    () => {},
    () => {
      setStatus((data) => !data);
      setLoading(false);
      //toast.success(res.data.message);
      handleCloseDialog();
    },
    () => {
      //toast.error(error.response.data.message);
      setLoading(false);
      handleCloseDialog();
    }
  );

  const submitBoardAccessibility = useCallback(() => {
    setLoading(true);
    archiveMutate({ board_id: params.row.board_id, data });
  }, [archiveMutate, data, params.row.board_id]);

  const handleOpenDialog = useCallback(()=>{
    setPrivatDialog(true);
  },[]);

  return (
    <>
      {privatDialog && (
        <FormDialog
          open={privatDialog}
          handleClose={handleCloseDialog}
          handleSubmit={submitBoardAccessibility}
          loading={loading}
          buttonTxt={isPrivate ? "Public" : "Private"}
          title={"Change Board Visibility"}
          cancelBtn={true}
          alignActions={"center"}
          fullWidth={true}
        >
          <Typography className="align_text_center mb-2">
            Are you sure to change the Board visibility?
          </Typography>
        </FormDialog>
      )}
      <div className="w-100 d-flex justify-content-center">
        <label class="custom-checkbox">
          <input
            type="checkbox"
            checked={status}
            onClick={handleOpenDialog}
          />
          <span class="checkmark"></span>
        </label>
      </div>
    </>
  );
}

const isChangeAccessibility = (prevProps, nextProps) => {
  return (
    prevProps?.params?.row?.board_id === nextProps?.params?.row?.board_id
    && prevProps?.params?.row?.is_private === nextProps?.params?.row?.is_private
  );
};

export default React.memo(Accessibility, isChangeAccessibility);
